<template>
  <div>
    <div class="chart-container">
      <div class="flex items-center justify-between">
        <div class="flex gap-2 items-center">
          <img src="../../assets/gift.svg" class="w-5 relative -top-0.5" />
          <h4>Gifting</h4>
        </div>
      </div>
      <div class="trending-header">
        <p>Total gifts sent in {{ new Date().getFullYear() }}</p>
      </div>
      <SkeletonLoader width="100%" height="160px" v-if="!loadStatus" />
      <section v-else>
        <div class="flex items-center gap-">
          <span class="chart-label text-left gifts-label">No. of Gifts </span>
          <div class="w-full">
            <LineChart
              :styles="myStyles"
              :height="150"
              :chartdata="historicalOrdersSent"
            />
            <span class="chart-label pt-2">Month</span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { progressStatus } from '../../helpers'
import LineChart from '@/components/ReportHelpers/LineChart'

export default {
  name: 'OrderChart',
  components: {
    LineChart,
    SkeletonLoader: () => import('@/components/Universal/Skeleton')
  },
  created() {
    this.$store.dispatch('report/createReportChart')
  },
  computed: {
    myStyles() {
      return {
        height: '250px',
        position: 'relative'
      }
    },
    loadStatus() {
      return progressStatus(this.loadBarChart)
    },
    ...mapState({
      loadBarChart: state => state.report.loadBarChart,
      historicalOrdersSent: state => state.report.historicalOrdersSent,
      countGiftsSent: state => state.report.countGiftsSent
    })
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.whitebutton-gemnote--small {
  font-size: 0.813rem;
  font-weight: normal;
  height: 2.5rem;
  width: max-content !important;
  padding: 0 0rem !important;
}

.button-gemnote-glass--tiny {
  width: max-content !important;
  font-weight: 400 !important;
  padding: 0 1rem !important;
}

.chart-container {
  padding: 1rem;
  border: 1px solid $main-6;
  border-radius: 2px;

  h4 {
    text-align: left;
    font-size: 1.25rem;
    font-family: $editorial;
    font-weight: normal;
  }
  .trending-header {
    margin: 1rem 0;
    p {
      text-align: left;
      font-size: 0.813rem;
    }
  }
}

.chart-label {
  font-size: 12px;
  font-family: $inter;
  font-weight: 700;
  &.gifts-label {
    width: 5%;
  }

  @media (max-width: 768px) {
    &.gifts-label {
      display: none;
    }
  }

  &.pt-2 {
    display: block;
    margin-top: 0.5rem;
    margin-right: 2.5rem;
  }
}
</style>
